import React from 'react';

import { useAppSelector, useAuthFlow } from '@pkg/hooks';

import { useLegacyWalletStore, useWalletStore } from '@app/store/zustand';

import { Icon } from '../../SidebarNav/Icon';
import { WalletButtonStyled, WalletStatus } from '../styles';

export const WalletButton = () => {
    const { setShowOverview } = useLegacyWalletStore();
    const { protectedAction } = useAuthFlow();

    const wallets = useWalletStore((state) => state.connectedWallets);

    const isRegisteredUser = useAppSelector((state) => state.user?.isRegisteredUser);

    function handleOpenWalletManager() {
        protectedAction(() => {
            setShowOverview(true);
        });
    }

    if (!isRegisteredUser || !wallets || wallets.length === 0)
        return (
            <WalletButtonStyled onClick={handleOpenWalletManager}>
                <Icon name="wallet" />
                <span>Connect a wallet</span>
                <WalletStatus $status="red" />
            </WalletButtonStyled>
        );

    return (
        <WalletButtonStyled onClick={handleOpenWalletManager}>
            <Icon name="wallet" />
            <span>{wallets.length} Connected</span>
            <WalletStatus $status="green" />
        </WalletButtonStyled>
    );
};
